import { PolicyConfig } from "../constants/defaultCalculatorPolicyConfig";
import { ERequestMethods } from "../enums/RequestMethod";
import { ESYSTEM_SETTING, SettingSystemType } from "../enums/SystemSetting";
import { request } from "../libs/request";
import { IResponseData, ListResponseData } from "../types/requests";
import {
  ICreateUserSuspend,
  IUserSuspend,
  IUserSuspendUpdate,
} from "../types/suspension";
import { SystemSettingDTO } from "../types/SystemSetting";

function getKillSwitch() {
  return request<IResponseData<SystemSettingDTO>>({
    method: ERequestMethods.GET,
    url: ESYSTEM_SETTING.KILL_SWITCH,
  });
}

function getAgentDashboardTopBar() {
  return request<IResponseData<SystemSettingDTO>>({
    method: ERequestMethods.GET,
    url: ESYSTEM_SETTING.AGENT_DASHBOARD_TOP_BAR,
  });
}

function getUserSuspend() {
  return request<ListResponseData<IUserSuspend>>({
    method: ERequestMethods.GET,
    url: ESYSTEM_SETTING.GET_USER_SUSPEND,
  });
}

function createUserSuspend(data: ICreateUserSuspend) {
  return request<IResponseData<any>>({
    method: ERequestMethods.POST,
    url: ESYSTEM_SETTING.CREATE_USER_SUSPEND,
    data,
  });
}

function startKillSwitch(
  id: string,
  payload: {
    type: SettingSystemType;
    data: { reason: string };
    status: "active" | "inactive";
  },
) {
  return request<IResponseData<SystemSettingDTO>>({
    method: ERequestMethods.PATCH,
    url: ESYSTEM_SETTING.UPDATE(id),
    data: payload,
  });
}

function updateAgentDashboardTopBar(
  id: string,
  payload: {
    type: SettingSystemType;
    data: { message: string };
    status: "active" | "inactive";
  },
) {
  return request<IResponseData<SystemSettingDTO>>({
    method: ERequestMethods.PATCH,
    url: ESYSTEM_SETTING.UPDATE(id),
    data: payload,
  });
}

function updateUserSuspend(id: string, data: IUserSuspendUpdate) {
  return request<IResponseData<any>>({
    method: ERequestMethods.PATCH,
    url: ESYSTEM_SETTING.UPDATE_USER_SUSPEND(id),
    data,
  });
}

function deleteUserSuspend(id: string) {
  return request<IResponseData<any>>({
    method: ERequestMethods.DELETE,
    url: ESYSTEM_SETTING.DELETE_USER_SUSPEND(id),
  });
}

function updateCalculatorPolicy(id: string, payload: PolicyConfig) {
  return request<IResponseData<any>>({
    method: ERequestMethods.PATCH,
    url: ESYSTEM_SETTING.UPDATE(id),
    data: {
      data: payload,
      type: SettingSystemType.CALCULATOR_FORMULA,
    },
  });
}

function getCalculatorPolicy() {
  return request<IResponseData<any>>({
    method: ERequestMethods.GET,
    url: ESYSTEM_SETTING.UPDATE_CALCULATOR_POLICY,
  });
}

const SystemSettingRepository = Object.freeze({
  getKillSwitch,
  getAgentDashboardTopBar,
  startKillSwitch,
  updateAgentDashboardTopBar,
  getUserSuspend,
  updateUserSuspend,
  deleteUserSuspend,
  createUserSuspend,
  updateCalculatorPolicy,
  getCalculatorPolicy,
});

export default SystemSettingRepository;
